import { CommonDataSetAction, ItemAttrListDataSet } from '@mri/types';

export function cardGetActionIconRender( action: CommonDataSetAction, prop: ItemAttrListDataSet): string {
  if(typeof action.icon === 'function') return action.icon(prop);

  return action.icon;
}